<template>
    <div class="new_activity_answer">
        <div class="header" :style="{'background-image':'url('+detail.imgurl+')'}">
            <div class="mvbutton small text-white" @click="showrule=true">活动规则</div>
            <!-- <div class="mvbutton small text-white rank" @click="gorank">活动排行</div> -->
            <img @click="goshare" class="rankIcon" src="https://oss.mcloud.moveclub.cn/2025/g100/icon2.png" alt="">
            <img @click="gorank " class="rankIcon2" src="https://oss.mcloud.moveclub.cn/2025/g100/icon.png" alt="">
        </div>
        <div class="body" style="margin-top: -.3rem;">
            <Questions @submitAnswer="submitAnswer" :questions="questions" v-if="questions.length"
                       @selectAnswer="selectAnswer" :type="type" :answerInfo="answerInfo"></Questions>
        </div>
        <!-- <van-overlay :show="showrule"  >
            <div class="wrapper">
                <div class="block">
                    <div class="block_header">
                        <div>规则说明</div>
                        <img :src="require('assets/img/mwap/colse.png')" alt="" @click="showrule = false">
                    </div>
                    <div class="block_body" v-html="rule"></div>                    
                </div>                
            </div>
        </van-overlay> -->
        <transition name="succeed">
            <div v-show="showrule" class="succeed">
                <div class="mask" @click="showrule=false"></div>
                <div class="box">
                    <div class="rule-title">活动规则</div>
                    <div class="rule" v-html="rule"></div>
                </div>
            </div>
        </transition>
        <van-popup closeable round v-model="showform" style="height: 4rem;width: 6.1rem;">
            <Form :list="attrs" :ispop="true" buttonColor="#009F45"  @submit="submit"/>
        </van-popup>
        <van-popup closeable round v-model="showCert" style="height: 10rem;width: 6rem;background: transparent;">
            <img :src="cert" style="width: 6rem;height: 8rem;">
            <div style="display: flex; align-items: center;justify-content: center;margin-top: .3rem;">
                <img src="https://oss.mcloud.moveclub.cn/2025/g100/btn.png" style="width: 2.3rem;height: .65rem;"></img>
            </div>
        </van-popup>
    </div>
</template>

<script>
    import './index.less'
    import Questions from './questions/index'
    import { Overlay } from 'vant';  
    import Form from '@/components/form/popform.vue'

    export default {
        name: "answer",
        data() {
            return {
                answerInfo: {
                    correctcount: 0,
                    score: 0
                },
                type: '',
                showrule: false,
                showform: false,
                rule: "",
                questions: [],
                questionname: "",
                detail: {},
                attrs: [],
                registerinfos: null,
                showCert: false,
                cert: ''
            }
        },
        components: {
            vanOverlay:Overlay,
            Questions,
            Form
        },
        methods: {
            goshare() {
                this.$toast.success("请点击右上角‘...’分享")
            },
            submit: function (e) {
                this.$dialog.confirm({
                    title: "提示",
                    confirmButtonText: '确定提交',
                    message: '信息提交后不可修改,确定提交?',
                    showCancelButton: true
                }).then(() => {
                    console.log(e)
                    this.$api.activity.submitCombine({registerinfos:JSON.stringify(e),combile_id:54}).then((res) => {
                        if (+res.status === 200) {
                            this.getother()
                            this.showform = false
                        }
                    })

                    // on confirm
                }).catch(() => {
                    // on cancel
                });   
            },
            getother: function () {
                this.$api.activity.memberAttrList({typeid:1691}).then((res)=>{
                    this.attrs = res.data.list[0]['attrs']
                })
                this.$api.activity.getCombine({combile_id:54}).then((res)=>{
                    let {disclaimer_url,registerinfos} = res.data;
                    this.registerinfos = registerinfos?registerinfos:null
                    if(!this.registerinfos) {
                        this.showform = true
                    }
                })

            },
            submitAnswer() {
                this.$toast.loading({duration: 0, loadingType: "spinner"})
                let answer = [];
                let correctcount = 0;
                for (var i in this.questions) {
                    if (this.questions[i]['correct']) correctcount++
                    if (this.questions[i]['selected'] !== undefined) {
                        answer.push({
                            qid: this.questions[i].qid,
                            answer: this.questions[i].selected
                        })
                    } else {
                        this.$toast.clear();
                        this.$toast.fail("请回答完所有问题后再提交")
                        return;
                    }
                }
                if (answer.length) {
                    this.$api.answer.submitQuestions({aid:this.$route.params.acid,answer: JSON.stringify(answer)}).then((res) => {
                        if (res.status * 1 === 200) {
                            this.questions = [1]
                            this.answerInfo = {
                                correctcount,
                                score: res.data.score
                            }
                            this.type = 'answerFinsh';
                            this.$storage.remove(this.questionname)
                            if(this.$route.params.acid == 1356) {
                                this.$api.activity
                                    .getCert({id: this.$route.params.acid})
                                    .then(res => {
                                        this.cert = res.data.cert
                                        this.showCert = true
                                    });
                            }
                            
                        }
                        this.$toast.clear();
                    })
                }

            },
            selectAnswer(key, ckey) {
                var currentquestion = this.questions;
                currentquestion[key]['selected'] = ckey + 1
                var courrent = this.cf.AesDecrypt(currentquestion[key]["answer"])
                if (ckey + 1 == courrent) {
                    currentquestion[key]['correct'] = true;
                } else {
                    currentquestion[key]['correct'] = false;
                }
                this.$set(this.questions, key, currentquestion[key]);
                this.$storage.set(this.questionname, currentquestion)
            },
            gorank() {
                this.$router.push({name:'answerRank',params:{aid:this.$route.params.acid}})
            },
            getQuestions() {
                this.$toast.loading({duration: 0, loadingType: "spinner"})
                //查看本地缓存
                this.$api.answer.questions({aid:this.$route.params.acid}).then((res) => {
                    if (res.status * 1 === 200) {
                        this.detail = res.data.activity
                        return res.data;
                    } else {
                        this.$toast.clear();
                    }
                }).then((apires) => {

                    this.rule = apires.rule;
                    if(apires.qtoday && apires.qtoday*1===1){
                        this.type = 'answered';
                        this.questions = ['1']
                        this.$toast.clear();
                        return
                    } else {
                        this.type = 'answerList'
                    }
                    // this.questions = apires.questions;
                    // this.$storage.set(this.questionname, apires.questions)
                    this.$storage.get(this.questionname).then((res) => {
                        if (res) {
                            this.questions = res
                        } else {
                            this.questions = apires.questions;
                            this.$storage.set(this.questionname, apires.questions)
                        }
                    })
                    this.$toast.clear();

                })


            }
        },
        mounted() {
            this.$nextTick(() => {
								console.log('aid:this.$route.params.acid', this.$route.params.acid)
                let d = new Date();
                this.questionname = [d.getFullYear(), d.getMonth(), d.getDay()].join("-")
                this.getQuestions();

                var shareConf = {
                    title: '活动答题',
                    path:
                        '/pages/webview/index?src=https://bk.h5.movecloud.cn/newanswer/'+this.$route.params.acid,
                }

                wx.miniProgram.postMessage({ data: JSON.stringify(shareConf) });

                if(this.$route.params.acid == 1356) {
                    this.getother();
                }
            })
        }
    }
</script>
